import * as React from 'react';
import { useStylesForToolTip } from 'src/app/shared/components/tooltip/toolTip.styles';
import { MenuItem, Select, Tooltip } from '@material-ui/core';
import { FeaturesContext } from '../../domains/core/pataflag.context';
import { Features } from '../../domains/core/pataflag';

export const ZoneNames = {
    AMS: { label: 'AMS', value: 'R3AA1' },
    AOA: { label: 'AOA', value: 'R3AO1' },
    EUR: { label: 'EUR', value: 'R3AE1' },
    AOA_PS: { label: 'AOA_PS', value: 'R3AO1_PS' },
    EUR_PS: {label: 'EUR_PS', value: 'R3AE1_PS' }
};
  
export const DefaultZone = ZoneNames.EUR;

export const GenericZonesComponent = ({ zoneTab, setZoneTab }) => {
    const classes = useStylesForToolTip({});
    const { hasFeature } = React.useContext(FeaturesContext);
    return <div>
        {/* {
            hasFeature(Features.S2P_174338_SHOW_NEW_ZONE) ?
            <Tooltip
                classes={{ tooltip: classes.customTooltip }}
                placement='right'
                title={"Select a Zone"}>
                <Select disableUnderline={true} style={{ paddingLeft: 10 }} value={zoneTab} onChange={event => setZoneTab(event.target.value as string)}>
                    <MenuItem value={ZoneNames.AMS.value}>{ZoneNames.AMS.label}</MenuItem>
                    <MenuItem value={ZoneNames.AOA.value}>{ZoneNames.AOA.label}</MenuItem>
                    <MenuItem value={ZoneNames.EUR.value}>{ZoneNames.EUR.label}</MenuItem>
                    { hasFeature(Features.S2P_174338_SHOW_NEW_ZONE) && <MenuItem value={ZoneNames.AOA_PS.value}>{ZoneNames.AOA_PS.label}</MenuItem>}
                </Select>
            </Tooltip>
            :
            <Tooltip
                classes={{ tooltip: classes.customTooltip }}
                placement='right'
                title={"Select a Zone"}>
                <Select disableUnderline={true}
                    style={{ paddingLeft: 10 }}
                    value={zoneTab}
                    onChange={event => setZoneTab(event.target.value as string)}>
                    <MenuItem value={ZoneNames.AMS.value}>{ZoneNames.AMS.label}</MenuItem>
                    <MenuItem value={ZoneNames.AOA.value}>{ZoneNames.AOA.label}</MenuItem>
                    <MenuItem value={ZoneNames.EUR.value}>{ZoneNames.EUR.label}</MenuItem>
                </Select>
            </Tooltip>
        } */}
        <Tooltip
            classes={{ tooltip: classes.customTooltip }}
            placement='right'
            title={"Select a Zone"}>
            <Select disableUnderline={true} style={{ paddingLeft: 10 }} value={zoneTab} onChange={event => setZoneTab(event.target.value as string)}>
                <MenuItem value={ZoneNames.AMS.value}>{ZoneNames.AMS.label}</MenuItem>
                <MenuItem value={ZoneNames.AOA.value}>{ZoneNames.AOA.label}</MenuItem>
                {hasFeature(Features.S2P_174338_SHOW_NEW_ZONE) && <MenuItem value={ZoneNames.AOA_PS.value}>{ZoneNames.AOA_PS.label}</MenuItem>}
                <MenuItem value={ZoneNames.EUR.value}>{ZoneNames.EUR.label}</MenuItem>
                {hasFeature(Features.S2P_178559_SHOW_PPD_NEW_ZONE_EUR_PS) && <MenuItem value={ZoneNames.EUR_PS.value}>{ZoneNames.EUR_PS.label}</MenuItem>}
            </Select>
        </Tooltip>
    </div>
}